import * as React from 'react';
import _ from 'lodash';
import { Label } from 'semantic-grab-ui/src';
import { Limit } from 'types/ts/campaigns';

interface Props {
  limits: Limit[],
}

const LimitShow = (props:Props) => {
  return (
    <div>
      {
        _.isEmpty(props.limits)
          ? <p>Not Set</p>
          : _.map(props.limits, (limit) => {
            return (
              <Label basic>
                {_.startCase(limit.per)}
                <Label.Detail>{limit.limit}</Label.Detail>
              </Label>
            );
          })
      }
    </div>
  );
};

export default LimitShow;
